import type { SidePanel } from '../types';

export const EarlyRepayment: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./EarlyRepaymentPanel.vue')),
};
